<template>
  <dialog-layout
    title="Help"
    :fullscreen="fullscreen"
    :navIcon="navIcon"
    :dark="dark"
    @pop-dialog="$emit('pop-dialog')"
  >
    <template v-slot:toolbar-actions>
      <v-menu class="dialog__menu" location="bottom end">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            icon
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item title="" @click="$emit('push-dialog', 'terms-of-service')">
            <v-list-item-title>Terms of service</v-list-item-title>
          </v-list-item>

          <v-list-item title="" @click="$emit('push-dialog', 'privacy-policy')">
            <v-list-item-title>Privacy policy</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>

    <v-list>
      <v-list-subheader>Information</v-list-subheader>

      <v-list-item
        title=""
        prepend-icon="mdi-frequently-asked-questions"
        @click="$emit('push-dialog', 'frequently-asked-questions')"
      >
        <v-list-item-title>FAQ</v-list-item-title>
      </v-list-item>

      <v-list-subheader>Contact us</v-list-subheader>

      <v-list-item
        title=""
        prepend-icon="mdi-message-alert"
        @click="$emit('push-dialog', 'send-feedback')"
      >
        <v-list-item-title>Send feedback</v-list-item-title>
      </v-list-item>
    </v-list>
  </dialog-layout>
</template>

<script>
import { DialogLayout } from "vue-app-components";

export default {
  name: "dialog-help",
  components: {
    DialogLayout
  },
  props: {
    fullscreen: {
      type: Boolean,
      required: true
    },
    navIcon: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean,
      default: false
    }
  }
};
</script>
